module.exports = __webpack_public_path__ + "static/media/best_me_1.68b48678.jpg";